/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/no-autofocus */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/prop-types */
/* eslint-disable import/prefer-default-export */
import React, { useState, useMemo, useRef, useEffect, useCallback } from 'react'
import { FixedSizeList as List } from 'react-window'
import clsx from 'clsx'
import { useMedia } from 'hooks/useMedia'
import styles from './DropdownSelect.module.css'
import { useClickOutside } from 'hooks/useClickOutside'

import { SearchIcon } from './SearchIcon'
import { CheckIcon } from './CheckIcon'

const MOBILE_HEADER_OFFSET = 272

const Row = React.memo(({ data, index, style }) => {
  const { filteredOptions, selectedValues, toggleValue } = data
  const option = filteredOptions[index]
  const isChecked = selectedValues.includes(option.value)

  return (
    <div
      className={styles.dropdownItem}
      style={style}
      onClick={(e) => {
        e.stopPropagation()
        toggleValue(option.value)
      }}
    >
      <div style={{ width: 20 }}>{isChecked ? <CheckIcon /> : null}</div>
      <div className={styles.dropdownContent}>{option.content || option.label}</div>
    </div>
  )
})

export const DropdownSelect = ({
  options,
  itemHeight = 40,
  maxVisibleItems = 12,
  inputPlaceholder = 'Search...',
  selectedValuesFunc = (values) => `${values} Values`,
  values,
  onApply,
  className,
  onClear,
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const [search, setSearch] = useState('')
  const [viewSelectedMode, setViewSelectedMode] = useState(false)

  const [selectedValues, setSelectedValues] = useState(values || [])
  const triggerRef = useRef(null)
  const listRef = useRef(null)
  const dropDownRef = useRef(null)

  const isMobile = useMedia(['(max-width: 768px)'], [true], false)

  useEffect(() => {
    if (values.length > 0) {
      setSelectedValues(values)
    }
  }, [values])

  const selectedText = useMemo(() => selectedValuesFunc(selectedValues.length), [selectedValuesFunc, selectedValues])

  const optionsList = useMemo(() => {
    if (viewSelectedMode) {
      return options.filter((o) => selectedValues.includes(o.value))
    }

    return options
  }, [viewSelectedMode, options])

  const filteredOptions = useMemo(
    () => optionsList?.filter((o) => o.name?.toLowerCase().includes(search.toLowerCase())),
    [optionsList, search]
  )

  const toggleValue = useCallback((value) => {
    setSelectedValues((prev) => (prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value]))
  }, [])

  const itemData = useMemo(
    () => ({ filteredOptions, selectedValues, toggleValue }),
    [filteredOptions, selectedValues, toggleValue]
  )

  const handleApply = useCallback(() => {
    setIsOpen(false)
    onApply(selectedValues)
  }, [selectedValues])

  const handleClear = useCallback(() => {
    setSelectedValues([])
    setIsOpen(false)
    onClear()
  }, [])

  useEffect(() => {
    if (isOpen && listRef.current && selectedValues.length > 0) {
      const firstSelected = filteredOptions.findIndex((o) => selectedValues.includes(o.value))
      if (firstSelected >= 0) {
        listRef.current.scrollToItem(firstSelected, 'center')
      }
    }
  }, [isOpen, filteredOptions])

  useEffect(() => {
    const close = (e) => {
      if (e.key === 'Escape') {
        setIsOpen(false)
      }
    }
    document.addEventListener('keyup', close)
    return () => document.removeEventListener('keyup', close)
  }, [])

  const handleViewSelected = useCallback(() => {
    if (viewSelectedMode) {
      setSelectedValues([])
      setViewSelectedMode(false)
    } else {
      setViewSelectedMode(true)
    }
  }, [viewSelectedMode])

  useClickOutside([dropDownRef, triggerRef], () => setIsOpen(false))

  return (
    <div className={clsx(styles.dropdownWrapper, className)}>
      <div
        ref={triggerRef}
        className={clsx(styles.trigger, isOpen && styles.openedTrigger)}
        onClick={() => setIsOpen(true)}
      >
        <span>{selectedText}</span>
        {selectedValues.length > 0 && (
          <button
            type="button"
            className={styles.clearButton}
            onClick={(e) => {
              e.stopPropagation()
              handleClear()
            }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
              <path
                d="M11.648 7.14797L9.79524 9L11.648 10.852C11.7002 10.9043 11.7417 10.9663 11.77 11.0346C11.7983 11.1029 11.8128 11.1761 11.8128 11.25C11.8128 11.3239 11.7983 11.3971 11.77 11.4654C11.7417 11.5337 11.7002 11.5957 11.648 11.648C11.5957 11.7002 11.5337 11.7417 11.4654 11.77C11.3971 11.7983 11.3239 11.8128 11.25 11.8128C11.1761 11.8128 11.1029 11.7983 11.0346 11.77C10.9663 11.7417 10.9043 11.7002 10.852 11.648L9 9.79523L7.14797 11.648C7.09571 11.7002 7.03367 11.7417 6.96538 11.77C6.8971 11.7983 6.82391 11.8128 6.75 11.8128C6.67609 11.8128 6.60291 11.7983 6.53462 11.77C6.46634 11.7417 6.4043 11.7002 6.35203 11.648C6.29977 11.5957 6.25832 11.5337 6.23003 11.4654C6.20175 11.3971 6.18719 11.3239 6.18719 11.25C6.18719 11.1761 6.20175 11.1029 6.23003 11.0346C6.25832 10.9663 6.29977 10.9043 6.35203 10.852L8.20477 9L6.35203 7.14797C6.24649 7.04242 6.18719 6.89927 6.18719 6.75C6.18719 6.60073 6.24649 6.45758 6.35203 6.35203C6.45758 6.24648 6.60074 6.18719 6.75 6.18719C6.89927 6.18719 7.04242 6.24648 7.14797 6.35203L9 8.20477L10.852 6.35203C10.9043 6.29977 10.9663 6.25831 11.0346 6.23003C11.1029 6.20174 11.1761 6.18719 11.25 6.18719C11.3239 6.18719 11.3971 6.20174 11.4654 6.23003C11.5337 6.25831 11.5957 6.29977 11.648 6.35203C11.7002 6.40429 11.7417 6.46634 11.77 6.53462C11.7983 6.6029 11.8128 6.67609 11.8128 6.75C11.8128 6.82391 11.7983 6.8971 11.77 6.96538C11.7417 7.03366 11.7002 7.09571 11.648 7.14797ZM16.3125 9C16.3125 10.4463 15.8836 11.8601 15.0801 13.0626C14.2766 14.2651 13.1346 15.2024 11.7984 15.7559C10.4622 16.3093 8.99189 16.4541 7.57341 16.172C6.15492 15.8898 4.85196 15.1934 3.82928 14.1707C2.80661 13.148 2.11017 11.8451 1.82801 10.4266C1.54586 9.00811 1.69067 7.53781 2.24413 6.20163C2.7976 4.86544 3.73486 3.72339 4.9374 2.91988C6.13993 2.11637 7.55373 1.6875 9 1.6875C10.9388 1.68955 12.7975 2.46063 14.1685 3.83154C15.5394 5.20246 16.3105 7.06123 16.3125 9ZM15.1875 9C15.1875 7.77623 14.8246 6.57994 14.1447 5.56241C13.4648 4.54488 12.4985 3.75181 11.3679 3.2835C10.2372 2.81518 8.99314 2.69264 7.79288 2.93139C6.59262 3.17014 5.49012 3.75944 4.62478 4.62478C3.75944 5.49011 3.17014 6.59262 2.93139 7.79288C2.69265 8.99314 2.81518 10.2372 3.2835 11.3679C3.75182 12.4985 4.54488 13.4648 5.56241 14.1447C6.57994 14.8246 7.77623 15.1875 9 15.1875C10.6405 15.1856 12.2132 14.5331 13.3732 13.3732C14.5331 12.2132 15.1856 10.6405 15.1875 9Z"
                fill="currentColor"
              />
            </svg>
          </button>
        )}
      </div>

      {isOpen && (
        <div className={styles.dropdownPanel} ref={dropDownRef}>
          <div className={styles.mobileHeader}>
            <div className={styles.mobileHeaderName}>{inputPlaceholder}</div>

            <svg
              className={styles.mobileClose}
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="23"
              viewBox="0 0 24 23"
              fill="none"
              onClick={() => setIsOpen(false)}
            >
              <path
                d="M19.7802 17.719C19.8499 17.7887 19.9052 17.8714 19.9429 17.9625C19.9806 18.0535 20 18.1511 20 18.2496C20 18.3482 19.9806 18.4457 19.9429 18.5368C19.9052 18.6278 19.8499 18.7105 19.7802 18.7802C19.7105 18.8499 19.6278 18.9052 19.5368 18.9429C19.4457 18.9806 19.3482 19 19.2496 19C19.1511 19 19.0535 18.9806 18.9625 18.9429C18.8714 18.9052 18.7887 18.8499 18.719 18.7802L12.5 12.5603L6.28097 18.7802C6.14025 18.9209 5.94939 19 5.75038 19C5.55136 19 5.3605 18.9209 5.21978 18.7802C5.07906 18.6395 5 18.4486 5 18.2496C5 18.0506 5.07906 17.8598 5.21978 17.719L11.4397 11.5L5.21978 5.28097C5.07906 5.14025 5 4.94939 5 4.75038C5 4.55136 5.07906 4.3605 5.21978 4.21978C5.3605 4.07906 5.55136 4 5.75038 4C5.94939 4 6.14025 4.07906 6.28097 4.21978L12.5 10.4397L18.719 4.21978C18.8598 4.07906 19.0506 4 19.2496 4C19.4486 4 19.6395 4.07906 19.7802 4.21978C19.9209 4.3605 20 4.55136 20 4.75038C20 4.94939 19.9209 5.14025 19.7802 5.28097L13.5603 11.5L19.7802 17.719Z"
                fill="#ECECEC"
              />
            </svg>
          </div>
          <div className={styles.searchBar}>
            <SearchIcon />
            <input
              placeholder={inputPlaceholder}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              onClick={(e) => {
                e.stopPropagation()
                setIsOpen(true)
              }}
              className={styles.triggerInput}
            />
          </div>

          {filteredOptions.length > 0 ? (
            <List
              ref={listRef}
              height={
                isMobile
                  ? window.innerHeight - MOBILE_HEADER_OFFSET
                  : Math.min(filteredOptions.length, maxVisibleItems) * itemHeight
              }
              itemCount={filteredOptions.length}
              itemSize={itemHeight}
              width="100%"
              itemData={itemData}
            >
              {Row}
            </List>
          ) : (
            <div className={styles.noResults}>No Results</div>
          )}

          <div className={styles.footer}>
            <button
              className={clsx(styles.viewSelectedButton, selectedValues.length > 0 && styles.viewSelectedButtonActive)}
              type="button"
              onClick={handleViewSelected}
            >
              {viewSelectedMode ? 'Clear All' : 'View Selected'}
            </button>
            <div className={styles.divider} />
            <button className={styles.applyButton} type="button" onClick={handleApply}>
              Apply {selectedValues.length > 0 && `(+${selectedValues.length})`}
            </button>
          </div>
        </div>
      )}
    </div>
  )
}
